export const Pokedex: {[k: string]: ModdedSpeciesData} = {
	pikachu: {
		inherit: true,
		formeOrder: ["Pikachu"],
	},
	articuno: {
		inherit: true,
		unreleasedHidden: true,
	},
	zapdos: {
		inherit: true,
		unreleasedHidden: true,
	},
	moltres: {
		inherit: true,
		unreleasedHidden: true,
	},
	snivy: {
		inherit: true,
		unreleasedHidden: true,
	},
	servine: {
		inherit: true,
		unreleasedHidden: true,
	},
	serperior: {
		inherit: true,
		unreleasedHidden: true,
	},
	tepig: {
		inherit: true,
		unreleasedHidden: true,
	},
	pignite: {
		inherit: true,
		unreleasedHidden: true,
	},
	emboar: {
		inherit: true,
		unreleasedHidden: true,
	},
	oshawott: {
		inherit: true,
		unreleasedHidden: true,
	},
	dewott: {
		inherit: true,
		unreleasedHidden: true,
	},
	samurott: {
		inherit: true,
		unreleasedHidden: true,
	},
	skrelp: {
		inherit: true,
		unreleasedHidden: true,
	},
	dragalge: {
		inherit: true,
		unreleasedHidden: true,
	},
	tyrunt: {
		inherit: true,
		unreleasedHidden: true,
	},
	tyrantrum: {
		inherit: true,
		unreleasedHidden: true,
	},
	amaura: {
		inherit: true,
		unreleasedHidden: true,
	},
	aurorus: {
		inherit: true,
		unreleasedHidden: true,
	},
};
